import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import type { TFunction } from 'i18next';
import CustomTooltip from '../../../../../Components/Tooltip/CustomTooltip';
import { retailCellSource, rowCellText } from './columns';
import { EMPTY_CELL, I18N_NAMESPACE } from './product-identifier-v2.constants';
import type { RangePlanIdentifierRow, ResolvedColumn, RetailCardSummary, ViewLabels } from './types';

interface IdentifierCellProps {
  row: RangePlanIdentifierRow | undefined;
  columnKey: string;
  definition: ResolvedColumn | undefined;
  labels: ViewLabels;
  retailCards: Record<string, RetailCardSummary> | undefined;
  isFixed: boolean;
}

function retailTooltip(
  t: TFunction,
  row: RangePlanIdentifierRow,
  columnKey: string,
  definition: ResolvedColumn,
  retailCards: Record<string, RetailCardSummary> | undefined,
): string {
  const source = retailCellSource(row, columnKey, definition, retailCards);
  if (source.isManual) {
    return t('RANGE_PLAN_PRODUCT_IDENTIFIER.MANUALLY_ADDED');
  }
  return source.card ? t('RANGE_PLAN_PRODUCT_IDENTIFIER.RETAIL_SOURCE', { name: source.card.name }) : '';
}

function IdentifierCell({ row, columnKey, definition, labels, retailCards, isFixed }: IdentifierCellProps): React.ReactElement {
  const { t } = useTranslation(I18N_NAMESPACE);
  const text = row && definition ? rowCellText(row, definition, labels) : EMPTY_CELL;
  const tooltipText = row && definition?.retail && text !== EMPTY_CELL ? retailTooltip(t, row, columnKey, definition, retailCards) : '';

  return (
    <td className={isFixed ? 'first-fix-col' : undefined}>
      {tooltipText ? (
        <CustomTooltip tooltipText={tooltipText}>
          <span>{text}</span>
        </CustomTooltip>
      ) : (
        text
      )}
    </td>
  );
}

export default memo(IdentifierCell);
